export enum REGIONS {
  US = 'US', // USA
  CA = 'CA', // Canada
  GB = 'GB', // Great Britain / UK
  CH = 'CH', // Switzerland
  ZA = 'ZA' // South Africa
}

export enum LANGUAGES {
  en = 'en', // english
  fr = 'fr', // french
  de = 'de', // german
  it = 'it' // italian
}

export enum DOMAINS {
  com = '.com',
  ca = '.ca',
  ch = '.ch',
  uk = '.co.uk',
  za = '.co.za'
}

export enum MONEY_FORMAT {
  de_ch = 'CHF',
  en_us = '$US',
  en_ca = '$CA',
  en_ch = 'CHF',
  en_gb = 'GB£',
  fr_ca = 'CA$',
  fr_ch = 'CHF',
  it_ch = 'CHF',
  en_za = 'ZAR'
}

export enum CURRENCY_CODE_FORMAT {
  de_ch = 'CHF',
  en_us = 'USD',
  en_ca = 'CAD',
  en_ch = 'CHF',
  en_gb = 'GBP',
  fr_ca = 'CAD',
  fr_ch = 'CHF',
  it_ch = 'CHF',
  en_za = 'ZAR'
}

export enum LOCALES {
  en_ca = 'en-CA',
  en_ch = 'en-CH',
  en_gb = 'en-GB',
  en_us = 'en-US',
  fr_ca = 'fr-CA',
  fr_ch = 'fr-CH',
  it_ch = 'it-CH',
  de_ch = 'de-CH',
  en_za = 'en-ZA'
}

export type LocaleData = {
  code: LOCALES;
  region: REGIONS;
  language: LANGUAGES;
  moneyFormat?: MONEY_FORMAT;
  currencyCodeFormat?: CURRENCY_CODE_FORMAT;
};

export enum CURRENCY_PREFIX {
  dollar = '$'
}
